import React from 'react';

import {
    DndContext,
    closestCenter,
    KeyboardSensor,
    PointerSensor,
    useSensor,
    useSensors,
} from '@dnd-kit/core';

import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';

import {
    arrayMove,
    SortableContext,
    sortableKeyboardCoordinates,
    verticalListSortingStrategy,
} from '@dnd-kit/sortable';

import { useState } from 'react';

import { de } from 'date-fns/locale';
import { registerLocale } from 'react-datepicker';

import { useEffect, useRef } from 'react';

import { useParams } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';

import DatePicker from 'react-datepicker';

import 'react-datepicker/dist/react-datepicker.css';

import { Container } from 'react-bootstrap';
import { Row } from 'react-bootstrap';
import { Col } from 'react-bootstrap';
import { Alert } from 'react-bootstrap';

import { Form } from 'react-bootstrap';
import { FormGroup } from 'react-bootstrap';
import { FormLabel } from 'react-bootstrap';
import { FormControl } from 'react-bootstrap';
import { Button } from 'react-bootstrap';
import { ButtonGroup } from 'react-bootstrap';
import { ListGroup } from 'react-bootstrap';

import { Editor } from '@tinymce/tinymce-react';

import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import ResourceStore from '../../../stores/ResourceStore';
import MediaUsageGoalStore from '../../../stores/MediaUsageGoalStore';
import ResourceTypeStore from '../../../stores/ResourceTypeStore';
import AuthorStore from '../../../stores/AuthorStore';

import SelectEntityPopup from './SelectEntityPopup';

let _timer = null;

registerLocale('de', de);

const PortalResourceEditPage = ({ users }) => {
    const [isImageListVisible, setIsImageListVisible] = useState(false);
    const [isArticleVisible, setIsArticleVisible] = useState(false);
    const [isPdfListVisible, setIsPdfListVisible] = useState(false);
    const [isSelectPopupVisible, setIsSelectPopupVisible] = useState(false);
    const [selectPopupListEntityType, setSelectPopupListEntityType] =
        useState(null);
    const [isToastVisible, setIsToastVisible] = useState(false);
    const [authors, setAuthors] = useState([]);

    const [isAuthorOrderLocked, setIsAuthorOrderLocked] = useState(true);

    const navigate = useNavigate();

    const sensors = useSensors(
        useSensor(
            PointerSensor,
            // This is needed to get the buttons to fire when they are in a draggable.
            // See https://github.com/clauderic/dnd-kit/issues/172, and https://github.com/clauderic/dnd-kit/issues/296#issuecomment-849841749
            {
                activationConstraint: {
                    distance: 10,
                },
            },
        ),
        useSensor(KeyboardSensor, {
            coordinateGetter: sortableKeyboardCoordinates,
        }),
    );

    const store = ResourceStore((state) => state);
    const mediaUsageGoalStore = MediaUsageGoalStore((state) => state);
    const resourceTypeStore = ResourceTypeStore((state) => state);

    const { portalResourceId } = useParams();

    const editorRef = useRef(null);

    const fileInput = useRef(null);

    useEffect(() => {
        mediaUsageGoalStore.loadAll();
        resourceTypeStore.loadAll();
        store.load(portalResourceId, (portalResource) => {
            setAuthors(portalResource.authors);
        });

        // The [] is for specifying dependencies, and for componentDidMount lifecycle equivalent
        // we need to specify no dependencies.
        // See https://stackoverflow.com/questions/53945763/componentdidmount-equivalent-on-a-react-function-hooks-component
    }, []);

    function SortableItem(props) {
        const { attributes, listeners, setNodeRef, transform, transition } =
            useSortable({ id: props.id });

        const style = {
            transform: CSS.Transform.toString(transform),
            transition,
        };

        const author = props.author;

        return (
            <ListGroup.Item
                key={'author-' + author.id}
                ref={setNodeRef}
                style={style}
                {...attributes}
                {...listeners}
            >
                {author.lastName +
                    ', ' +
                    author.firstName +
                    ' (' +
                    author.id +
                    ')'}

                <Button
                    style={{ marginLeft: '5px', float: 'right' }}
                    variant="success"
                >
                    Drag Me
                </Button>
            </ListGroup.Item>
        );
    }

    if (null == store.portalResource) {
        return <div>Loading ...</div>;
    }

    var availableMediaUsageGoals = mediaUsageGoalStore.mediaUsageGoals;
    var availableResourceTypes = resourceTypeStore.resourceTypes;

    var formInputElements = [];

    formInputElements.push(
        getFormInputComponent(store.portalResource, authors, 'id'),
    );
    formInputElements.push(
        getFormInputComponent(store.portalResource, authors, 'title'),
    );
    formInputElements.push(
        getFormInputComponent(store.portalResource, authors, 'shortTitle'),
    );
    formInputElements.push(
        getFormInputComponent(store.portalResource, authors, 'dataCreation'),
    );
    formInputElements.push(
        getFormInputComponent(store.portalResource, authors, 'dataUpdate'),
    );
    formInputElements.push(
        getFormInputComponent(
            store.portalResource,
            authors,
            'aggregateScientificQualityRating',
        ),
    );
    formInputElements.push(
        getFormInputComponent(
            store.portalResource,
            authors,
            'scientificQualityPdfUrl',
        ),
    );
    formInputElements.push(
        getFormInputComponent(
            store.portalResource,
            authors,
            'estimatedReadingTimeInMinutes',
        ),
    );
    formInputElements.push(
        getFormInputComponent(
            store.portalResource,
            authors,
            'aggregateUserRating',
        ),
    );
    formInputElements.push(
        getFormInputComponent(
            store.portalResource,
            authors,
            'isUserRatingVisible',
        ),
    );
	formInputElements.push(
        getFormInputComponent(
            store.portalResource,
            authors,
            'isFeaturedArticle',
        ),
    );
    formInputElements.push(
        getFormInputComponent(
            store.portalResource,
            authors,
            'isArticleVisible',
        ),
    );
    formInputElements.push(
        getFormInputComponent(
            store.portalResource,
            authors,
            'isScientificRatingVisible',
        ),
    );
    formInputElements.push(
        getFormInputComponent(store.portalResource, authors, 'authors'),
    );
    formInputElements.push(
        getFormInputComponent(store.portalResource, authors, 'resourceType'),
    );
    formInputElements.push(
        getFormInputComponent(
            store.portalResource,
            authors,
            'subjectMatterCategories',
        ),
    );
    formInputElements.push(
        getFormInputComponent(store.portalResource, authors, 'mediaUsageGoal'),
    );
    formInputElements.push(
        getFormInputComponent(store.portalResource, authors, 'schoolTypes'),
    );
	formInputElements.push(
        getFormInputComponent(store.portalResource, authors, 'titleMediaType'),
    );

	if("TITLE_MEDIA_TYPE_IMAGE" == store.portalResource.titleMediaType) {
		formInputElements.push(getFormInputComponent(store.portalResource, authors, 'titleImage'));
	}
	else {
		formInputElements.push(getFormInputComponent(store.portalResource, authors, 'titleVideo'));		
	}

    return (
        <Container style={{ marginTop: '10px', width: '100%' }}>
            {isSelectPopupVisible ? (
                <SelectEntityPopup
                    entityType={selectPopupListEntityType}
                    setIsSelectPopupVisible={setIsSelectPopupVisible}
                    portalResource={store.portalResource}
                />
            ) : null}

            <ToastContainer autoClose={2000} position="top-center" />

            <Row className="show-Container">
                <Col xs={12} md={8}>
                    <Button
                        onClick={() => {
                            navigate('/portalResource/');
                        }}
                    >
                        Back to list
                    </Button>
                    <div>PortalResource Edit Page</div>
                    <br />

                    <FormLabel style={{ fontSize: '2em', fontWeight: 'bold' }}>
                        Document Details
                    </FormLabel>

                    <form>
                        {formInputElements}

                        <br />
                        <br />

                        <Button
                            style={{ marginLeft: '5px' }}
                            onClick={() => {
                                navigate('/portalResource');
                            }}
                        >
                            Cancel
                        </Button>

                        <Button
                            style={{ marginLeft: '5px' }}
                            onClick={() => {
                                if (
                                    isNaN(
                                        store.portalResource
                                            .aggregateScientificQualityRating,
                                    )
                                ) {
                                    alert(
                                        'The value for Scientfic Quality Rating must be number.',
                                    );
                                } else if (
                                    isNaN(
                                        store.portalResource
                                            .estimatedReadingTimeInMinutes,
                                    )
                                ) {
                                    alert(
                                        'The value for Estimated Reading Time must be number.',
                                    );
                                } else {
                                    store.save(
                                        store.portalResource,
                                        () => {
                                            alert('Your edits were saved');
                                            navigate('/portalResource');
                                        },
                                        () => {
                                            alert('Something went wrong!');
                                        },
                                    );
                                }
                            }}
                        >
                            Save
                        </Button>

                        <Button
                            style={{ marginLeft: '5px' }}
                            onClick={() => {
                                store.delete(
                                    store.portalResource.id,
                                    () => {
                                        alert('The resource was deleted');
                                        navigate('/portalResource');
                                    },
                                    () => {
                                        alert('Something went wrong!');
                                    },
                                );
                            }}
                        >
                            Delete
                        </Button>

                        <div>
                            <hr
                                style={{
                                    marginTop: '30px',
                                    backgroundColor: 'black',
                                    height: '15px',
                                }}
                            />
                        </div>

                        {buildImagesAndPdfsPanel()}

                        <div>
                            <hr
                                style={{
                                    marginTop: '30px',
                                    backgroundColor: 'black',
                                    height: '15px',
                                }}
                            />
                        </div>

                        <div style={{ marginTop: '40px' }}>
                            <FormGroup
                                key={'sections-title'}
                                controlId={'sections-title'}
                            >
                                <FormLabel
                                    style={{
                                        fontSize: '2em',
                                        fontWeight: 'bold',
                                    }}
                                >
                                    Text Sections
                                </FormLabel>

                                {getUntterichtsKonzeptInfoAlert(
                                    store.portalResource,
                                )}

                                <Button
                                    style={{ marginLeft: '20px' }}
                                    disabled={isAddSectionButtonDisabled(
                                        store.portalResource,
                                    )}
                                    onClick={() => {
                                        store.addSection(
                                            store.portalResource.id,
                                            {
                                                heading: 'New Section',
                                                text: 'Text goes here...',
                                            },
                                        );
                                    }}
                                >
                                    Add Section
                                </Button>
                            </FormGroup>

                            {null == store.portalResource.sections
                                ? null
                                : store.portalResource.sections.map(
                                      (section, i) => {
                                          return (
                                              <div
                                                  key={'section-panel-' + i}
                                                  style={{ marginTop: '30px' }}
                                              >
                                                  <h4>
                                                      <FormGroup
                                                          key={
                                                              'form-section-title' +
                                                              i
                                                          }
                                                          controlId={
                                                              'form-section-title' +
                                                              i
                                                          }
                                                      >
                                                          <FormLabel>
                                                              Section
                                                          </FormLabel>

                                                          <Button
                                                              style={{
                                                                  marginLeft:
                                                                      '5px',
                                                              }}
                                                              onClick={() => {
                                                                  store.saveSection(
                                                                      section,
                                                                      () => {
                                                                          alert(
                                                                              'Your edits were saved',
                                                                          );
                                                                          store.load(
                                                                              portalResourceId,
                                                                          );
                                                                      },
                                                                      () => {
                                                                          alert(
                                                                              'Something went wrong!',
                                                                          );
                                                                      },
                                                                  );
                                                              }}
                                                          >
                                                              Save Text
                                                          </Button>

                                                          <Button
                                                              style={{
                                                                  marginLeft:
                                                                      '5px',
                                                              }}
                                                              onClick={() => {
                                                                  store.deleteSection(
                                                                      section.id,
                                                                      () => {
                                                                          alert(
                                                                              'The section was deleted',
                                                                          );
                                                                          store.load(
                                                                              portalResourceId,
                                                                          );
                                                                      },
                                                                      () => {
                                                                          alert(
                                                                              'Something went wrong!',
                                                                          );
                                                                      },
                                                                  );
                                                              }}
                                                          >
                                                              Delete
                                                          </Button>

                                                          <Button
                                                              style={{
                                                                  marginLeft:
                                                                      '5px',
                                                              }}
                                                              disabled={isAddSubSectionButtonDisabled(
                                                                  store.portalResource,
                                                              )}
                                                              onClick={() => {
                                                                  store.addSubSection(
                                                                      section.id,
                                                                      {
                                                                          heading:
                                                                              'New SubSection',
                                                                          text: 'Text goes here...',
                                                                      },
                                                                  );
                                                              }}
                                                          >
                                                              Add SubSection
                                                          </Button>

                                                          <div
                                                              style={{
                                                                  marginTop:
                                                                      '10px',
                                                              }}
                                                          ></div>

                                                          <FormControl
                                                              type="text"
                                                              value={
                                                                  section.heading
                                                              }
                                                              onChange={(e) => {
                                                                  store.updateSection(
                                                                      i,
                                                                      e.target
                                                                          .value,
                                                                      section.text,
                                                                  );
                                                              }}
                                                          />
                                                      </FormGroup>
                                                  </h4>

                                                  <Editor
                                                      onInit={(evt, editor) =>
                                                          (editorRef.current =
                                                              editor)
                                                      }
                                                      value={section.text}
                                                      init={{
                                                          height: 700,
                                                          menubar: false,
                                                          plugins: [
                                                              'code',
                                                              'image',
                                                              'lists',
                                                              'table',
                                                              'link',
															  'media'
                                                          ],
                                                          toolbar:
                                                              'undo redo | formatselect | ' +
                                                              'bold italic forecolor fontselect fontsize backcolor | alignleft aligncenter ' +
                                                              'alignright alignjustify | bullist numlist outdent indent | ' +
                                                              'removeformat | help | code | image | table | link | media ',
                                                          content_style:
                                                              'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }',
                                                          relative_urls: false,
                                                          convert_urls: false,
                                                          remove_script_host: false,
                                                      }}
                                                      onEditorChange={(
                                                          content,
                                                      ) => {
                                                          store.updateSection(
                                                              i,
                                                              section.heading,
                                                              content,
                                                          );
                                                      }}
                                                  />

                                                  {null == section.subSections
                                                      ? null
                                                      : section.subSections.map(
                                                            (subSection, j) => {
                                                                return (
                                                                    <div
                                                                        key={
                                                                            'subsection-panel-' +
                                                                            i +
                                                                            '-' +
                                                                            j
                                                                        }
                                                                        style={{
                                                                            marginTop:
                                                                                '30px',
                                                                            marginLeft:
                                                                                '50px',
                                                                        }}
                                                                    >
                                                                        <h4>
                                                                            <FormGroup
                                                                                key={
                                                                                    'form-subsection-title' +
                                                                                    i
                                                                                }
                                                                                controlId={
                                                                                    'form-subsection-title' +
                                                                                    i
                                                                                }
                                                                            >
                                                                                <FormLabel>
                                                                                    SubSection{' '}
                                                                                </FormLabel>

                                                                                <Button
                                                                                    style={{
                                                                                        marginLeft:
                                                                                            '15px',
                                                                                    }}
                                                                                    onClick={() => {
                                                                                        store.saveSubSection(
                                                                                            subSection,
                                                                                            () => {
                                                                                                alert(
                                                                                                    'Your edits were saved',
                                                                                                );
                                                                                                store.load(
                                                                                                    portalResourceId,
                                                                                                );
                                                                                            },
                                                                                            () => {
                                                                                                alert(
                                                                                                    'Something went wrong!',
                                                                                                );
                                                                                            },
                                                                                        );
                                                                                    }}
                                                                                >
                                                                                    Save
                                                                                    Text
                                                                                </Button>

                                                                                <Button
                                                                                    style={{
                                                                                        marginLeft:
                                                                                            '5px',
                                                                                    }}
                                                                                    onClick={() => {
                                                                                        store.deleteSubSection(
                                                                                            section.id,
                                                                                            subSection.id,
                                                                                            () => {
                                                                                                alert(
                                                                                                    'The SubSection was deleted',
                                                                                                );
                                                                                                store.load(
                                                                                                    portalResourceId,
                                                                                                );
                                                                                            },
                                                                                            () => {
                                                                                                alert(
                                                                                                    'Something went wrong!',
                                                                                                );
                                                                                            },
                                                                                        );
                                                                                    }}
                                                                                >
                                                                                    Delete
                                                                                </Button>

                                                                                <div
                                                                                    style={{
                                                                                        marginTop:
                                                                                            '10px',
                                                                                    }}
                                                                                ></div>

                                                                                <FormControl
                                                                                    type="text"
                                                                                    value={
                                                                                        subSection.heading
                                                                                    }
                                                                                    onChange={(
                                                                                        e,
                                                                                    ) => {
                                                                                        store.updateSubSection(
                                                                                            i,
                                                                                            j,
                                                                                            e
                                                                                                .target
                                                                                                .value,
                                                                                            subSection.text,
                                                                                        );
                                                                                    }}
                                                                                />
                                                                            </FormGroup>
                                                                        </h4>

                                                                        <Editor
                                                                            onInit={(
                                                                                evt,
                                                                                editor,
                                                                            ) =>
                                                                                (editorRef.current =
                                                                                    editor)
                                                                            }
                                                                            value={
                                                                                null ==
                                                                                subSection.text
                                                                                    ? ''
                                                                                    : subSection.text.replace(
                                                                                          '""',
                                                                                          '"',
                                                                                      )
                                                                            }
                                                                            init={{
                                                                                height: 700,
                                                                                menubar: false,
                                                                                plugins:
                                                                                    [
                                                                                        'code',
                                                                                        'image',
                                                                                        'lists',
                                                                                        'table',
																						'media'
                                                                                    ],
                                                                                toolbar:
                                                                                    'undo redo | formatselect | ' +
                                                                                    'bold italic forecolor fontselect fontsize backcolor | alignleft aligncenter ' +
                                                                                    'alignright alignjustify | bullist numlist outdent indent | ' +
                                                                                    'removeformat | help | code | image | table | media ',
                                                                                content_style:
                                                                                    'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }',
                                                                                relative_urls: false,
                                                                                convert_urls: false,
                                                                                remove_script_host: false,
                                                                            }}
                                                                            onEditorChange={(
                                                                                content,
                                                                            ) => {
                                                                                store.updateSubSection(
                                                                                    i,
                                                                                    j,
                                                                                    subSection.heading,
                                                                                    content,
                                                                                );
                                                                            }}
                                                                        />
                                                                    </div>
                                                                );
                                                            },
                                                        )}

                                                  <hr
                                                      style={{
                                                          marginTop: '30px',
                                                          backgroundColor:
                                                              'black',
                                                          height: '15px',
                                                      }}
                                                  />
                                              </div>
                                          );
                                      },
                                  )}
                        </div>

                        <br />
                        <br />
                    </form>
                </Col>
            </Row>
        </Container>
    );

    function isAddSectionButtonDisabled(portalResource) {
        if (null == portalResource.resourceType) {
            return false;
        } else if (null == portalResource.sections) {
            return false;
        } else if (
            'Unterrichtskonzept' == portalResource.resourceType.name &&
            2 <= portalResource.sections.length
        ) {
            return true;
        } else {
            return false;
        }
    }

    function isAddSubSectionButtonDisabled(portalResource) {
        if (null == portalResource.resourceType) {
            return false;
        } else {
            return 'Unterrichtskonzept' == portalResource.resourceType.name;
        }
    }

    function getUntterichtsKonzeptInfoAlert(portalResource) {
        if (null == portalResource.resourceType) {
            return false;
        } else if ('Unterrichtskonzept' == portalResource.resourceType.name) {
            return (
                <Alert key={'secondary'} variant={'info'}>
                    <p>
                        Important Note: For resources with type
                        "Unterrichtskonzept", only two Sections may be added:
                    </p>
                    <ol>
                        <li>
                            1) The first section is the text that appears to the
                            left of the main picture.
                        </li>
                        <li>
                            2) The second section is the link that appears in
                            the white box underneath the main picture.
                        </li>
                    </ol>

                    <p>Also, No subsections may be added.</p>
                </Alert>
            );
        } else {
            return null;
        }
    }

    function getFormInputComponent(portalResource, authors, attributeName) {
        var self = this;

        switch (attributeName) {
            case 'id':
                return (
                    <FormGroup
                        style={{ marginTop: '8px' }}
                        key={'form-' + attributeName}
                        controlId={attributeName}
                    >
                        <FormLabel>ID</FormLabel>
                        <FormControl
                            type="text"
                            readOnly
                            disabled
                            value={portalResource.id}
                        />
                    </FormGroup>
                );

            case 'title':
                return (
                    <FormGroup
                        style={{ marginTop: '8px' }}
                        key={'form-' + attributeName}
                        controlId={attributeName}
                    >
                        <FormLabel>Title</FormLabel>
                        <FormControl
                            type="text"
                            value={portalResource.title}
                            onChange={(e) => {
                                store.updateAttribute('title', e.target.value);
                            }}
                        />
                    </FormGroup>
                );

            case 'shortTitle':
                return (
                    <FormGroup
                        style={{ marginTop: '8px' }}
                        key={'form-' + attributeName}
                        controlId={attributeName}
                    >
                        <FormLabel>Short Title</FormLabel>
                        <FormControl
                            type="text"
                            value={portalResource.shortTitle}
                            onChange={(e) => {
                                store.updateAttribute(
                                    'shortTitle',
                                    e.target.value,
                                );
                            }}
                        />
                    </FormGroup>
                );

            case 'dataCreation':
                return (
                    <FormGroup
                        style={{ marginTop: '8px' }}
                        key={'form-' + attributeName}
                        controlId={attributeName}
                    >
                        <FormLabel style={{ marginRight: '8px' }}>
                            Date of creation
                        </FormLabel>
                        <DatePicker
                            showIcon
                            locale="de"
                            selected={portalResource.dateCreation}
                            onChange={(date) => {
                                store.updateAttribute(
                                    'dateCreation',
                                    date.getTime(),
                                );
                            }}
                        />
                    </FormGroup>
                );

            case 'dataUpdate':
                return (
                    <FormGroup
                        style={{ marginTop: '8px' }}
                        key={'form-' + attributeName}
                        controlId={attributeName}
                    >
                        <FormLabel style={{ marginRight: '8px' }}>
                            Date of update
                        </FormLabel>
                        <DatePicker
                            showIcon
                            locale="de"
                            selected={portalResource.dateUpDate}
                            onChange={(date) => {
                                store.updateAttribute(
                                    'dateUpDate',
                                    date.getTime(),
                                );
                            }}
                        />
                    </FormGroup>
                );

            case 'authors':
                let handleDragEnd = (event) => {
                    const { active, over } = event;

                    if (active.id !== over.id) {
                        setAuthors((authors) => {
                            let oldIndex = -1;
                            for (let i = 0; i < authors.length; i++) {
                                if (active.id == authors[i].id) {
                                    oldIndex = i;
                                }
                            }

                            let newIndex = -1;
                            for (let i = 0; i < authors.length; i++) {
                                if (over.id == authors[i].id) {
                                    newIndex = i;
                                }
                            }

                            let newItems = arrayMove(
                                authors,
                                oldIndex,
                                newIndex,
                            );

                            // Modify the ordinal positions of each of the items
                            for (let i = 0; i < authors.length; i++) {
                                newItems[i].position = i;
                            }

                            store.updateAttribute('authors', newItems);

                            return newItems;
                        });
                    }
                };

                return (
                    <div>
                        <Button
                            style={{
                                marginBottom: '10px',
                                float: 'right',
                                marginLeft: '10px',
                            }}
                            onClick={() => {
                                setIsAuthorOrderLocked(!isAuthorOrderLocked);
                            }}
                        >
                            {isAuthorOrderLocked
                                ? 'Unlock Order'
                                : 'Lock Order'}
                        </Button>

                        <FormGroup
                            style={{ marginTop: '8px' }}
                            key={'form-' + attributeName}
                            controlId={attributeName}
                        >
                            <FormLabel>
                                Authors
                                <Button
                                    style={{ marginLeft: '8px' }}
                                    disabled={!isAuthorOrderLocked}
                                    onClick={() => {
                                        setIsSelectPopupVisible(true);
                                        setSelectPopupListEntityType('authors');
                                    }}
                                >
                                    Add
                                </Button>
                            </FormLabel>
                            <ListGroup>
                                {isAuthorOrderLocked
                                    ? buildAuthorsList(portalResource.authors)
                                    : null}
                            </ListGroup>
                        </FormGroup>

                        {null == authors || isAuthorOrderLocked ? null : (
                            <DndContext
                                sensors={sensors}
                                collisionDetection={closestCenter}
                                onDragEnd={handleDragEnd}
                            >
                                <SortableContext
                                    items={portalResource.authors}
                                    strategy={verticalListSortingStrategy}
                                >
                                    <ListGroup>
                                        {null == authors
                                            ? null
                                            : authors.map((author, i) => {
                                                  return (
                                                      <SortableItem
                                                          key={author.id}
                                                          id={author.id}
                                                          author={author}
                                                          authors={authors}
                                                          authorIndex={i}
                                                      />
                                                  );
                                              })}
                                    </ListGroup>
                                </SortableContext>
                            </DndContext>
                        )}
                    </div>
                );

            case 'resourceType':
                let resourceTypeOptions = [
                    { name: 'Choose a Resource Type' },
                ].concat(availableResourceTypes);

                return (
                    <FormGroup
                        style={{ marginTop: '8px' }}
                        key={'form-' + attributeName}
                        controlId={attributeName}
                    >
                        <FormLabel>Resource Type</FormLabel>

                        <Form.Select
                            aria-label="Default select example"
                            onChange={(e) => {
                                let resourceTypeIndex = e.target.value;
                                let newResourceType =
                                    resourceTypeOptions[resourceTypeIndex];
                                store.updateAttribute(
                                    'resourceType',
                                    newResourceType,
                                );
                            }}
                        >
                            {resourceTypeOptions.map(
                                (resourceType, resourceTypeIndex) => {
                                    let isSelected =
                                        null == portalResource.resourceType
                                            ? false
                                            : resourceType.id ==
                                              portalResource.resourceType.id;

                                    return (
                                        <option
                                            value={resourceTypeIndex}
                                            selected={isSelected}
                                        >
                                            {resourceType.name +
                                                (null != resourceType.id
                                                    ? ' (' +
                                                      resourceType.id +
                                                      ')'
                                                    : '')}
                                        </option>
                                    );
                                },
                            )}
                        </Form.Select>
                    </FormGroup>
                );

            case 'subjectMatterCategories':
                return (
                    <FormGroup
                        style={{ marginTop: '8px' }}
                        key={'form-' + attributeName}
                        controlId={attributeName}
                    >
                        <FormLabel>
                            Subject Matter Categories
                            <Button
                                style={{ marginLeft: '8px' }}
                                onClick={() => {
                                    setIsSelectPopupVisible(true);
                                    setSelectPopupListEntityType(
                                        'subjectMatterCategories',
                                    );
                                }}
                            >
                                Add
                            </Button>
                        </FormLabel>
                        <ListGroup>
                            {buildSubjectMatterCategoriesList(
                                portalResource.subjectMatterCategories,
                            )}
                        </ListGroup>
                    </FormGroup>
                );

            case 'mediaUsageGoal':
                let mediaUsageGoalOptions = [
                    { goal: 'Choose a Media Usage Goal' },
                ].concat(availableMediaUsageGoals);

                return (
                    <FormGroup
                        style={{ marginTop: '8px' }}
                        key={'form-' + attributeName}
                        controlId={attributeName}
                    >
                        <FormLabel>Media Usage Goal</FormLabel>

                        <Form.Select
                            aria-label="Default select example"
                            onChange={(e) => {
                                let mediaUsageGoalIndex = e.target.value;
                                let newMediaUsageGoal =
                                    mediaUsageGoalOptions[mediaUsageGoalIndex];
                                store.updateAttribute(
                                    'mediaUsageGoal',
                                    newMediaUsageGoal,
                                );
                            }}
                        >
                            {mediaUsageGoalOptions.map(
                                (mediaUsageGoal, mediaUsageGoalIndex) => {
                                    let isSelected =
                                        null == portalResource.mediaUsageGoal
                                            ? false
                                            : mediaUsageGoal.goal ==
                                              portalResource.mediaUsageGoal
                                                  .goal;

                                    return (
                                        <option
                                            value={mediaUsageGoalIndex}
                                            selected={isSelected}
                                        >
                                            {mediaUsageGoal.goal +
                                                (null != mediaUsageGoal.id
                                                    ? ' (' +
                                                      mediaUsageGoal.id +
                                                      ')'
                                                    : '')}
                                        </option>
                                    );
                                },
                            )}
                        </Form.Select>
                    </FormGroup>
                );

            case 'schoolTypes':
                return (
                    <FormGroup
                        style={{ marginTop: '8px' }}
                        key={'form-' + attributeName}
                        controlId={attributeName}
                    >
                        <FormLabel>
                            School Types
                            <Button
                                style={{ marginLeft: '8px' }}
                                onClick={() => {
                                    setIsSelectPopupVisible(true);
                                    setSelectPopupListEntityType('schoolTypes');
                                }}
                            >
                                Add
                            </Button>
                        </FormLabel>
                        <ListGroup>
                            {null == portalResource.schoolTypes
                                ? null
                                : portalResource.schoolTypes.map(
                                      (schoolType, i) => {
                                          return (
                                              <ListGroup.Item>
                                                  {schoolType.name +
                                                      ' (' +
                                                      schoolType.id +
                                                      ')'}
                                                  <Button
                                                      style={{
                                                          marginLeft: '5px',
                                                          float: 'right',
                                                      }}
                                                      onClick={() => {
                                                          var newSchoolTypes =
                                                              JSON.parse(
                                                                  JSON.stringify(
                                                                      portalResource.schoolTypes,
                                                                  ),
                                                              );
                                                          newSchoolTypes.splice(
                                                              i,
                                                              1,
                                                          );
                                                          store.updateAttribute(
                                                              'schoolTypes',
                                                              newSchoolTypes,
                                                          );
                                                      }}
                                                  >
                                                      Remove
                                                  </Button>
                                              </ListGroup.Item>
                                          );
                                      },
                                  )}
                        </ListGroup>
                    </FormGroup>
                );

            case 'isUserRatingVisible':
                return (
                    <FormGroup
                        style={{ marginTop: '8px' }}
                        key={'form-' + attributeName}
                        controlId={attributeName}
                    >
                        <FormLabel>User Rating Visibility Setting</FormLabel>

                        <ButtonGroup style={{ marginLeft: '10px' }}>
                            <Button
                                variant={
                                    portalResource.isUserRatingVisible
                                        ? 'primary'
                                        : 'secondary'
                                }
                                onClick={() => {
                                    store.updateAttribute(
                                        'isUserRatingVisible',
                                        true,
                                    );
                                }}
                            >
                                Visible
                            </Button>
                            <Button
                                variant={
                                    portalResource.isUserRatingVisible
                                        ? 'secondary'
                                        : 'primary'
                                }
                                onClick={() => {
                                    store.updateAttribute(
                                        'isUserRatingVisible',
                                        false,
                                    );
                                }}
                            >
                                Hide
                            </Button>
                        </ButtonGroup>
                    </FormGroup>
                );

            case 'isArticleVisible':
                return (
                    <FormGroup
                        style={{ marginTop: '8px' }}
                        key={'form-' + attributeName}
                        controlId={attributeName}
                    >
                        <FormLabel>Article Visibility Setting</FormLabel>

                        <ButtonGroup style={{ marginLeft: '10px' }}>
                            <Button
                                variant={
                                    portalResource.isArticleVisible
                                        ? 'primary'
                                        : 'secondary'
                                }
                                onClick={() => {
                                    store.updateAttribute(
                                        'isArticleVisible',
                                        true,
                                    );
                                }}
                            >
                                Visible
                            </Button>
                            <Button
                                variant={
                                    portalResource.isArticleVisible
                                        ? 'secondary'
                                        : 'primary'
                                }
                                onClick={() => {
                                    store.updateAttribute(
                                        'isArticleVisible',
                                        false,
                                    );
                                }}
                            >
                                Hide
                            </Button>
                        </ButtonGroup>
                    </FormGroup>
                );

            case 'isScientificRatingVisible':
                return (
                    <FormGroup
                        style={{ marginTop: '8px' }}
                        key={'form-' + attributeName}
                        controlId={attributeName}
                    >
                        <FormLabel>
                            Scientific Rating Visibility Setting
                        </FormLabel>

                        <ButtonGroup style={{ marginLeft: '10px' }}>
                            <Button
                                variant={
                                    portalResource.isScientificRatingVisible
                                        ? 'primary'
                                        : 'secondary'
                                }
                                onClick={() => {
                                    store.updateAttribute(
                                        'isScientificRatingVisible',
                                        true,
                                    );
                                }}
                            >
                                Visible
                            </Button>
                            <Button
                                variant={
                                    portalResource.isScientificRatingVisible
                                        ? 'secondary'
                                        : 'primary'
                                }
                                onClick={() => {
                                    store.updateAttribute(
                                        'isScientificRatingVisible',
                                        false,
                                    );
                                }}
                            >
                                Hide
                            </Button>
                        </ButtonGroup>
                    </FormGroup>
                );
				
			case 'isFeaturedArticle':
		                return (
		                    <FormGroup
		                        style={{ marginTop: '8px' }}
		                        key={'form-' + attributeName}
		                        controlId={attributeName}
		                    >
		                        <FormLabel>Featured Article (to appear at front of results)</FormLabel>

		                        <ButtonGroup style={{ marginLeft: '10px' }}>
		                            <Button
		                                variant={
		                                    portalResource.isFeaturedArticle
		                                        ? 'secondary'
		                                        : 'primary'
		                                }
		                                onClick={() => {
		                                    store.updateAttribute(
		                                        'isFeaturedArticle',
		                                        false,
		                                    );
		                                }}
		                            >
		                                Normal
		                            </Button>
		                            <Button
		                                variant={
		                                    portalResource.isFeaturedArticle
		                                        ? 'primary'
		                                        : 'secondary'
		                                }
		                                onClick={() => {
		                                    store.updateAttribute(
		                                        'isFeaturedArticle',
		                                        true,
		                                    );
		                                }}
		                            >
		                                Featured
		                            </Button>
		                        </ButtonGroup>
		                    </FormGroup>
		                );

            case 'aggregateScientificQualityRating':
                return (
                    <FormGroup
                        style={{ marginTop: '8px' }}
                        key={'form-' + attributeName}
                        controlId={attributeName}
                    >
                        <FormLabel>
                            Scientific Qualtity Rating (max. 3)
                        </FormLabel>
                        <FormControl
                            type="number"
                            min="0"
                            max="3"
                            step="0.25"
                            value={
                                portalResource.aggregateScientificQualityRating
                            }
                            onChange={(e) => {
                                let textVal = e.target.value;
                                store.updateAttribute(
                                    'aggregateScientificQualityRating',
                                    parseFloat(textVal),
                                );
                            }}
                        />
                    </FormGroup>
                );

            case 'estimatedReadingTimeInMinutes':
                return (
                    <FormGroup
                        style={{ marginTop: '8px' }}
                        key={'form-' + attributeName}
                        controlId={attributeName}
                    >
                        <FormLabel>Estimated Reading Time (mins)</FormLabel>
                        <FormControl
                            type="number"
                            min="5"
                            max="300"
                            step="15"
                            value={portalResource.estimatedReadingTimeInMinutes}
                            onChange={(e) => {
                                let textVal = e.target.value;
                                store.updateAttribute(
                                    'estimatedReadingTimeInMinutes',
                                    parseFloat(textVal),
                                );
                            }}
                        />
                    </FormGroup>
                );

            case 'aggregateUserRating':
                return (
                    <FormGroup
                        style={{ marginTop: '8px' }}
                        key={'form-' + attributeName}
                        controlId={attributeName}
                    >
                        <FormLabel>Estimated User Rating (max. 5)</FormLabel>
                        <FormControl
                            type="number"
                            min="0"
                            max="5"
                            step="0.25"
                            value={portalResource.aggregateUserRating}
                            onChange={(e) => {
                                let textVal = e.target.value;
                                store.updateAttribute(
                                    'aggregateUserRating',
                                    parseFloat(textVal),
                                );
                            }}
                        />
                    </FormGroup>
                );

			case 'titleMediaType':
				return <FormGroup
	                        style={{ marginTop: '8px' }}
	                        key={'form-' + attributeName}
	                        controlId={attributeName}
	                    >
	                        <FormLabel>
	                            Title Media Type
	                        </FormLabel>
	
	                        <ButtonGroup style={{ marginLeft: '10px' }}>
	                            <Button
	                                variant={
	                                    "TITLE_MEDIA_TYPE_IMAGE" == portalResource.titleMediaType
	                                        ? 'primary'
	                                        : 'secondary'
	                                }
	                                onClick={() => {
	                                    store.updateAttribute('titleMediaType', "TITLE_MEDIA_TYPE_IMAGE");
	                                }}
	                            >
	                                Image
	                            </Button>
	                            <Button
	                                variant={
	                                    "TITLE_MEDIA_TYPE_VIDEO" == portalResource.titleMediaType
	                                        ? 'primary'
	                                        : 'secondary'
	                                }
	                                onClick={() => {
	                                    store.updateAttribute('titleMediaType', "TITLE_MEDIA_TYPE_VIDEO");
	                                }}
	                            >
	                                Video
	                            </Button>
	                        </ButtonGroup>
					</FormGroup>;

            case 'titleImage':
				return <FormGroup
                        style={{ marginTop: '8px' }}
                        key={'form-' + attributeName}
                        controlId={attributeName}
                    >

						<div style={{marginLeft: "20px", marginTop: "10px"}}>

							<FormLabel>Image URL</FormLabel>
	                        <FormControl
	                            type="url"
	                            placeholder="Enter Image URL here..."
	                            value={ portalResource.titleImage }
	                            onChange={(e) => {
		                            store.updateAttribute('titleImage', e.target.value);
	                            }}
	                        />

						</div>
						
						{buildMediaThumbnail("TITLE_MEDIA_TYPE_IMAGE", portalResource)}
                    </FormGroup>;

			case 'titleVideo':
				return <FormGroup
                        style={{ marginTop: '8px' }}
                        key={'form-' + attributeName}
                        controlId={attributeName}
                    >
                        
						<div style={{marginLeft: "20px", marginTop: "10px"}}>

							<FormLabel>Video URL</FormLabel>
	                        <FormControl
	                            type="url"
	                            placeholder="Enter Video URL here..."
	                            value={ portalResource.titleVideo }
	                            onChange={(e) => {
									store.updateAttribute("titleVideo", e.target.value);
	                            }}
	                        />

						</div>
						
						{buildMediaThumbnail("TITLE_MEDIA_TYPE_VIDEO", portalResource)}
                    </FormGroup>;

            case 'scientificQualityPdfUrl':
                return (
                    <FormGroup
                        style={{ marginTop: '8px' }}
                        key={'form-' + attributeName}
                        controlId={attributeName}
                    >
                        <FormLabel>
                            Scientific Evaluation Document (Pdf){' '}
                        </FormLabel>
                        <FormControl
                            type="url"
                            placeholder="Enter pdf URL here..."
                            value={portalResource.scientificQualityPdfUrl || ''}
                            onChange={(e) => {
                                store.updateAttribute(
                                    'scientificQualityPdfUrl',
                                    e.target.value,
                                );
                            }}
                        />
                    </FormGroup>
                );

            default:
                return null;
        }
    }

	function buildMediaThumbnail(titleMediaType, portalResource){
		if("TITLE_MEDIA_TYPE_IMAGE" == titleMediaType){
			
			if(null == portalResource.titleImage){
				return null;
			}
			else {
				return <div style={{
						marginLeft: "20px", marginTop: "10px",
                        width: '150px',
                        height: '150px',
                        overflow: 'hidden',
                        border: '1px solid #ccc',
                }}>
                    
					<img src={portalResource.titleImage} alt="Title Image Preview" style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover',
                    }}/>
				</div>;
			}	
		}
		else {
			if(false && null == portalResource.titleVideo){
				return null;
			}
			else {
				return <iframe
					style={{marginLeft: "20px", marginTop: "10px"}}
                    width="315"
                    src={portalResource.titleVideo}
                    title="YouTube video player"
                    frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    referrerpolicy="strict-origin-when-cross-origin"
                    allowfullscreen
                ></iframe>;
			}			
		}
		
	}

    function buildAuthorsList(authors) {
        if (null == authors) {
            return null;
        } else {
            return authors.map((author, i) => {
                return (
                    <ListGroup.Item>
                        {author.lastName +
                            ', ' +
                            author.firstName +
                            ' (' +
                            author.id +
                            ')'}

                        <Button
                            style={{ marginLeft: '5px', float: 'right' }}
                            onClick={() => {
                                var newAuthors = JSON.parse(
                                    JSON.stringify(authors),
                                );
                                newAuthors.splice(i, 1);
                                store.updateAttribute('authors', newAuthors);
                            }}
                        >
                            Remove
                        </Button>
                    </ListGroup.Item>
                );
            });
        }
    }

    function buildSubjectMatterCategoriesList(subjectMatterCategories) {
        if (null == subjectMatterCategories) {
            return null;
        } else {
            return subjectMatterCategories.map((category, i) => {
                return (
                    <ListGroup.Item>
                        {category.category + ' (' + category.id + ')'}
                        <Button
                            style={{ marginLeft: '5px' }}
                            onClick={() => {
                                var newSubjectMatterCategories = JSON.parse(
                                    JSON.stringify(subjectMatterCategories),
                                );
                                newSubjectMatterCategories.splice(i, 1);
                                store.updateAttribute(
                                    'subjectMatterCategories',
                                    newSubjectMatterCategories,
                                );
                            }}
                        >
                            Remove
                        </Button>
                    </ListGroup.Item>
                );
            });
        }
    }

    function buildImagesAndPdfsPanel() {
        let collection = isImageListVisible
            ? store.availableImages
            : store.availablePdfs;

        return (
            <>
                <FormLabel style={{ fontSize: '2em', fontWeight: 'bold' }}>
                    Images and Pdfs
                </FormLabel>

                <Alert
                    key={'secondary'}
                    variant={'secondary'}
                    style={{ textAlign: 'right' }}
                >
                    <Button
                        style={{ marginLeft: '15px' }}
                        onClick={() => {
                            setIsImageListVisible(!isImageListVisible);
                            setIsPdfListVisible(false);

                            store.listAvailableImages(
                                store.portalResource.id,
                                () => {},
                                () => {},
                            );
                        }}
                    >
                        {isImageListVisible ? 'Hide' : 'Show'} Available Images
                    </Button>

                    <Button
                        style={{ marginLeft: '15px' }}
                        onClick={() => {
                            setIsPdfListVisible(!isPdfListVisible);
                            setIsImageListVisible(false);

                            store.listAvailablePdfs(
                                store.portalResource.id,
                                () => {},
                                () => {},
                            );
                        }}
                    >
                        {isPdfListVisible ? 'Hide' : 'Show'} Available Pdfs
                    </Button>

                    {!isImageListVisible
                        ? null
                        : buildAvailableFilesPanel(
                              isImageListVisible,
                              collection,
                          )}

                    {!isPdfListVisible
                        ? null
                        : buildAvailableFilesPanel(
                              isImageListVisible,
                              collection,
                          )}
                </Alert>
            </>
        );
    }

    function buildAvailableFilesPanel(isImageListVisible, collection) {
        let fileType = isImageListVisible ? 'image' : 'pdf';
        let fileTypeHumanReadable =
            fileType[0].toUpperCase() + fileType.substring(1, fileType.length);

        return (
            <div
                style={{
                    marginTop: '30px',
                    backgroundColor: '#f3f3f1',
                    padding: '10px',
                }}
            >
                <h3>Available {fileTypeHumanReadable + 's'}</h3>

                <ul style={{ listStyle: 'number' }}>
                    {null == collection
                        ? null
                        : collection.map((filename, i) => {
                              var url =
                                  window.location.origin +
                                  (isImageListVisible ? '/img-u' : '/pdf-u') +
                                  '/portalResources/' +
                                  store.portalResource.id +
                                  '/' +
                                  filename;

                              return (
                                  <li style={{ marginTop: '8px' }}>
                                      {url}

                                      <Button
                                          style={{ marginLeft: '15px' }}
                                          onClick={() => {
                                              navigator.clipboard.writeText(
                                                  url,
                                              );
                                              toast('URL copied to clipboard');
                                          }}
                                      >
                                          Copy
                                      </Button>

                                      <Button
                                          style={{ marginLeft: '15px' }}
                                          onClick={() => {
                                              store.deleteFile(
                                                  store.portalResource.id,
                                                  filename,
                                                  fileType,
                                              );
                                          }}
                                      >
                                          Remove
                                      </Button>
                                  </li>
                              );
                          })}
                </ul>

                <div style={{ marginTop: '10px' }}></div>

                <hr />

                <h5>Upload New {fileTypeHumanReadable}</h5>

                <FormControl
                    type="file"
                    style={{ marginLeft: '15px', float: 'right' }}
                    filename={store.fileForUpload}
                    ref={fileInput}
                    onChange={(e) => {
                        store.setFileForUpload(e.target.files[0]);
                    }}
                />

                <Button
                    style={{ marginTop: '15px' }}
                    disabled={null == store.fileForUpload}
                    onClick={() => {
                        var file = store.fileForUpload;
                        store.uploadFile(
                            store.portalResource.id,
                            file,
                            fileType,
                            () => {
                                // Reset file input widget
                                fileInput.current.value = '';
                                fileInput.current.type = 'text';
                                fileInput.current.type = 'file';

                                alert('Upload successful!');
                            },
                            () => {
                                alert('Something went wrong with the upload!');
                            },
                        );
                    }}
                >
                    Upload
                </Button>
            </div>
        );
    }
};

export default PortalResourceEditPage;
